module.exports = __webpack_public_path__ + "static/media/linkedin.62f1b416.svg";